import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilterSelectionDialogComponent } from '../../dialogs/filter-selection/filter-selection.component';
import { ReportsService } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';
import { PredefinedFiltersService, ServerFilter } from 'src/app/services/predefined-filters.service';

@Component({
  selector: 'server-side-filter',
  templateUrl: './server-side-filter.component.html',
  styleUrls: ['./server-side-filter.component.scss'],
})
export class ServerSideFilterComponent implements OnInit, OnDestroy {
  activeFilters: ServerFilter[] = [];
  filterSubscription: Subscription;

  constructor(
    private dialog: MatDialog,
    public rptService: ReportsService,
    public cService: CommonService,
    public predefinedFiltersService: PredefinedFiltersService
  ) {}

  ngOnInit() {
    this.filterSubscription = this.predefinedFiltersService.getActiveFilters().subscribe({
      next: (filters: ServerFilter[]) => (this.activeFilters = filters),
    });
  }

  displayServerFiltersModal() {
    this.dialog.open(FilterSelectionDialogComponent, {
      minHeight: '30%',
      minWidth: '30%',
      disableClose: true,
    });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }
}
